export const ADD_TO_CART = 'AddToCart';
export const VIEW_CONTENT = 'ViewContent';
export const SEARCH = 'Search';
export const INITIATE_CHECKOUT = 'InitiateCheckout';
export const ADD_PAYMENT_INFO = 'AddPaymentInfo';
export const PURCHASE = 'Purchase';
export const ADD_TO_WISHLIST = 'AddToWishlist';
